import React from 'react'
import classnames from 'classnames'

import formStyles from '../../styles/modules/each-item/each-item-forms.module.scss'
import { LANGUAGE_CODES, SupportedLanguageCode } from '../../../core/i18n'

interface Props {
  activeLanguage: SupportedLanguageCode
  onLanguageChange: (language: SupportedLanguageCode) => void
  width?: string
}

const PageLanguageTabs: React.FC<Props> = ({
  activeLanguage,
  onLanguageChange,
  width,
}) => (
  <div
    className={formStyles.pageLanguageTabs}
    style={width ? { width } : undefined}
  >
    <button
      className={classnames(formStyles.pageLanguageTab, {
        [formStyles.activePageTab]: activeLanguage === LANGUAGE_CODES.JAPANESE,
      })}
      onClick={() => onLanguageChange(LANGUAGE_CODES.JAPANESE)}
    >
      日本語
    </button>
    <button
      className={classnames(formStyles.pageLanguageTab, {
        [formStyles.activePageTab]: activeLanguage === LANGUAGE_CODES.ENGLISH,
      })}
      onClick={() => onLanguageChange(LANGUAGE_CODES.ENGLISH)}
    >
      英語
    </button>
  </div>
)

export default PageLanguageTabs
